export const PERSONAL_ACCOUNT = '/personal_account'
export const DETAILS = '/personal_account/'
export const STATEMENT = '/personal_account/statement'
export const TRANSFERS = '/personal_account/transfers'
export const INTRA_TRANSFERS = '/personal_account/intra_transfers'
export const EXCHANGE = '/personal_account/exchange'
export const PROFILE_INFO = '/personal_account/profile_info'
export const CHANGE_PASSWORD = '/personal_account/change_password'
